import { render, staticRenderFns } from "./InputField.vue?vue&type=template&id=2cc2206e&scoped=true"
import script from "./InputField.vue?vue&type=script&lang=ts"
export * from "./InputField.vue?vue&type=script&lang=ts"
import style0 from "./InputField.vue?vue&type=style&index=0&id=2cc2206e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc2206e",
  null
  
)

export default component.exports